import React from 'react'
import styled from '@emotion/styled'

import {Divider} from '@vio/atlas/Divider'
import {cssTheme} from '@vio/atlas/themes'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

import {AlternativeOfferInteraction} from './AlternativeOfferInteraction'
import {Primary, Secondary} from './Offer'

const ListWrapper = styled.div`
  border: solid 1px ${cssTheme.colors.border.neutral.secondary};
  width: 100%;
  border-top: none;
  border-radius: ${cssTheme.layout.radius.md};
  border-top-right-radius: 0;
  border-top-left-radius: 0;
`

type OffersListProps = {
  offers: SearchOffer[]
}

export const AlternativeOffersList = ({offers}: OffersListProps) => {
  return (
    <ListWrapper>
      {offers.map((offer, index) => (
        <React.Fragment key={offer.id}>
          <AlternativeOfferInteraction offer={offer}>
            {index === 0 ? (
              <Primary offer={offer} />
            ) : (
              <Secondary offer={offer} />
            )}
          </AlternativeOfferInteraction>
          {index > 0 && offers.length > 2 && index !== offers.length - 1 ? (
            <Divider sideMargin="s400" />
          ) : null}
        </React.Fragment>
      ))}
    </ListWrapper>
  )
}
